import toast from "@/lib/toast";
import { GetVideoResponseType } from "@/features/storage/sheets/hooks/useGetVideo";
import { Dispatch, SetStateAction } from "react";
import { VideoInteraction } from "@yedalabs/schema";
import { t } from "@/lib/localization";

export const useInteractionEdit = ({
    video,
    interactions,
    setInteractions,
    setSelectedInteraction,
    setChanges,
}: {
    video: GetVideoResponseType["data"];
    interactions: VideoInteraction[];
    setInteractions: Dispatch<SetStateAction<VideoInteraction[]>>;
    setSelectedInteraction: Dispatch<SetStateAction<VideoInteraction | null>>;
    setChanges: Dispatch<SetStateAction<boolean>>;
}) => {
    const updateInteraction = (
        id: string,
        fieldsToUpdate: Partial<VideoInteraction>
    ) => {
        if (
            fieldsToUpdate.timestamp &&
            (fieldsToUpdate.timestamp <= 0 ||
                (video.length && fieldsToUpdate.timestamp >= video.length))
        ) {
            toast.error(t("toast.error.interaction-timestamp-out-of-bounds"), {
                keyName: "toast.error.interaction-timestamp-out-of-bounds",
            });
            return;
        }
        if (
            fieldsToUpdate.timestamp &&
            !!interactions.find(
                (i) => i.id !== id && i.timestamp === fieldsToUpdate.timestamp
            )
        ) {
            toast.error(t("toast.error.interaction-timestamp-is-taken"), {
                keyName: "toast.error.interaction-timestamp-is-taken",
            });
            return;
        }
        if (
            (fieldsToUpdate.type === "close" ||
                fieldsToUpdate.type === "open" ||
                fieldsToUpdate.type === "audio") &&
            fieldsToUpdate?.content?.rewindTimestamp &&
            (fieldsToUpdate.content.rewindTimestamp < 0 ||
                (video.length &&
                    fieldsToUpdate.content.rewindTimestamp >= video.length))
        ) {
            toast.error(t("toast.error.interaction-timestamp-out-of-bounds"), {
                keyName: "toast.error.interaction-timestamp-out-of-bounds",
            });
            return;
        }

        setInteractions((prev) =>
            prev
                .map((i) =>
                    i.id === id
                        ? ({ ...i, ...fieldsToUpdate } as VideoInteraction)
                        : i
                )
                .sort((a, b) => a.timestamp - b.timestamp)
        );
        setSelectedInteraction((prev) =>
            prev && prev.id === id
                ? ({ ...prev, ...fieldsToUpdate } as VideoInteraction)
                : prev
        );
        setChanges(true);
    };

    return { updateInteraction };
};
